export default __webpack_public_path__ + "static/media/shipping_6414057.905c154b.png";